import type { ReactNode } from 'react';
import './BulkActionBar.css';

interface BulkActionBarProps {
  count: number;
  onClear: () => void;
  busy?: boolean;
  /** Short status line, e.g. "2 ready to approve". */
  hint?: string;
  children: ReactNode;
}

/**
 * Sticky bar shown when a table has multi-selected rows (Ctrl/Cmd+click).
 */
export function BulkActionBar({
  count,
  onClear,
  busy = false,
  hint,
  children,
}: BulkActionBarProps): JSX.Element | null {
  if (count === 0) return null;

  return (
    <div className="bulk-action-bar card" role="toolbar" aria-label="Bulk actions">
      <div className="bulk-action-meta">
        <span className="bulk-action-count">
          {count} selected
        </span>
        {hint ? <span className="bulk-action-hint">{hint}</span> : null}
        <span className="bulk-action-keys" title="Ctrl/Cmd+click to toggle · Shift+click for range · Esc to clear">
          Ctrl+click to multi-select
        </span>
      </div>
      <div className="bulk-action-actions">
        {children}
        <button
          type="button"
          className="btn-charcoal-secondary"
          onClick={onClear}
          disabled={busy}
        >
          Clear
        </button>
      </div>
    </div>
  );
}
